import { IPayment } from 'interfaces/INewBooking';

export const getLastTransactionDate = (
  transactions: IPayment[]
): string | null => {
  const lastTransaction = transactions
    ?.filter((transaction) => transaction.type === 'Payment')
    ?.shift();

  return lastTransaction?.paymentDate || null;
};
